/**
 * Pricing Data for Right Choice Health Care
 * Prices are in Kuwaiti Dinars (KD)
 */

export const pricingData = {
  // 12 Hours Duty Cycle
  shift12: [
    {
      id: '12h-daily',
      duration: { en: '1 Day', ar: 'يوم واحد' },
      price: '25',
      features: {
        en: [
          '12-hour professional care',
          'Medication assistance',
          'Mobility support',
        ],
        ar: [
          'رعاية مهنية لمدة ١٢ ساعة',
          'المساعدة في تناول الأدوية',
          'دعم الحركة والتنقل',
        ],
      },
      isPopular: false,
    },
    {
      id: '12h-weekly',
      duration: { en: '1 Week', ar: 'أسبوع واحد' },
      price: '130',
      features: {
        en: [
          '7 consecutive days',
          'Dedicated caregiver',
          'Daily status updates',
        ],
        ar: ['٧ أيام متتالية', 'مقدم رعاية مخصص', 'تحديثات يومية للحالة'],
      },
      isPopular: true, // Best Value highlight
    },
    {
      id: '12h-biweekly',
      duration: { en: '2 Weeks', ar: 'أسبوعين' },
      price: '220',
      features: {
        en: [
          '14 days coverage',
          'Priority scheduling',
          'Comprehensive hygiene care',
        ],
        ar: [
          'تغطية لمدة ١٤ يوماً',
          'أولوية في الجدولة',
          'رعاية شاملة للنظافة الشخصية',
        ],
      },
      isPopular: false,
    },
    {
      id: '12h-monthly',
      duration: { en: '1 Month', ar: 'شهر كامل' },
      price: '400',
      features: {
        en: [
          '30 days premium care',
          'Dedicated supervisor',
          'Monthly health report',
        ],
        ar: ['رعاية مميزة لمدة ٣٠ يوماً', 'مشرف مخصص للحالة', 'تقرير صحي شهري'],
      },
      isPopular: false,
    },
  ],

  // 24 Hours Duty Cycle
  shift24: [
    {
      id: '24h-daily',
      duration: { en: '1 Day', ar: 'يوم واحد' },
      price: '30',
      features: {
        en: [
          'Full 24-hour monitoring',
          'Feeding & hygiene support',
          'Night-time assistance',
        ],
        ar: [
          'مراقبة على مدار ٢٤ ساعة',
          'دعم التغذية والنظافة',
          'مساعدة خلال فترة الليل',
        ],
      },
      isPopular: false,
    },
    {
      id: '24h-weekly',
      duration: { en: '1 Week', ar: 'أسبوع واحد' },
      price: '170',
      features: {
        en: ['Full week live-in care', 'Vitals monitoring', 'Companionship'],
        ar: [
          'رعاية مقيمة لمدة أسبوع',
          'مراقبة المؤشرات الحيوية',
          'صحبة ودعم نفسي',
        ],
      },
      isPopular: true, // Best Value highlight
    },
    {
      id: '24h-biweekly',
      duration: { en: '2 Weeks', ar: 'أسبوعين' },
      price: '260',
      features: {
        en: [
          'Premium live-in support',
          'Wound care management',
          'Specialized diet feeding',
        ],
        ar: [
          'دعم مقيم متميز',
          'إدارة العناية بالجروح',
          'التغذية بنظام غذائي متخصص',
        ],
      },
      isPopular: false,
    },
    {
      id: '24h-monthly',
      duration: { en: '1 Month', ar: 'شهر كامل' },
      price: '480',
      features: {
        en: [
          'Full month 24/7 care',
          'Professional nursing team',
          'Total peace of mind',
        ],
        ar: [
          'رعاية ٢٤/٧ لمدة شهر',
          'فريق تمريض محترف',
          'راحة بال تامة للعائلة',
        ],
      },
      isPopular: false,
    },
  ],
};
